import React from "react";
import styles from "@styles/components/seasonEpisodes.scss";
import { useImageFallback } from "@hooks/useImageFallback";

const EpisodeCard = ({ episode, index, isActive, style, onClick }) => {
  const imageSrc = useImageFallback(episode.poster);

  // Calculate progress percentage
  const progressPercentage =
    episode.watched?.time && episode.duration
      ? (episode.watched.time / episode.duration) * 100
      : 0;

  return (
    <div style={style} onClick={onClick}>
      <div className={`episode ${isActive ? "active" : ""}`}>
        <img
          src={imageSrc}
          alt={episode.name}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        <p className="episode-title">{index + 1}</p>
        {episode.watched?.time > 0 && (
          <div className="progress-bar">
            <div
              className="progress"
              style={{ width: `${episode.watched.percent}%` }}
            ></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EpisodeCard;
